export const dictionary = {
    charts: {
        auto: 'auto',
        pie: 'pie',
        bar: 'bar'
    }
};
